import React, { FC, useState, useEffect } from 'react';
import { message, Skeleton } from 'antd';
import Axios from 'axios';
import { BsArrowRight } from 'react-icons/bs';
import { ToogleLinkButton } from 'app/components/ToogleLinkButton/ToogleLinkButton';
import { BUTTON } from 'app/components/ToogleLinkButton/models.d';
import { getBanner, BannerI } from 'app/adapters/Banner';
import { sanitizedContent } from 'app/utils/sanitizedContent';
import './HPBanner.scss';

const HPBanner: FC = () => {
  const [banner, setBanner] = useState<BannerI | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const getBannerData = async () => {
    try {
      const { data } = await getBanner().finally(() => {
        setIsLoading(false);
      });
      setBanner(data.results[0]);
    } catch (error) {
      if (!Axios.isCancel(error)) {
        message.error('An error occurred while fetching the banner data');
      }
    }
  };

  useEffect(() => {
    getBannerData();
  }, []);

  return (
    <>
      {isLoading ? (
        <Skeleton
          active
          paragraph={false}
          title={{
            style: { height: '460px', width: '100%' },
          }}
        />
      ) : banner ? (
        <div className="hp-banner-wrapper">
          <img
            src={banner.image}
            alt="banner"
            className="hp-banner-wrapper__img"
          />
          <div className="hp-banner">
            <div
              dangerouslySetInnerHTML={sanitizedContent(
                '<h2>' + banner.description + '</h2>',
              )}
              className="hp-banner__description-wrapper"
            />
            <div className="hp-banner__btn">
              {banner.internal_page || banner.internal_insight ? (
                <ToogleLinkButton
                  version={BUTTON.VERSION.INTERNAL_LINK}
                  link={
                    banner.internal_page
                      ? `/${banner.internal_page.slug}`
                      : banner.internal_insight
                      ? `/insights/${banner.internal_insight.page_url}`
                      : ''
                  }
                  variant={BUTTON.VARIANT.OUTLINE}
                  color={BUTTON.COLOR.ORANGE}
                  size={BUTTON.SIZE.BIG}
                  round={BUTTON.ROUND.MEDIUM_LIGHT}
                  AppendChild={<BsArrowRight />}
                >
                  {banner.button_text}
                </ToogleLinkButton>
              ) : banner.external_url ? (
                <ToogleLinkButton
                  version={BUTTON.VERSION.EXTERNAL_LINK}
                  link={banner.external_url}
                  variant={BUTTON.VARIANT.OUTLINE}
                  color={BUTTON.COLOR.ORANGE}
                  size={BUTTON.SIZE.BIG}
                  round={BUTTON.ROUND.MEDIUM_LIGHT}
                  AppendChild={<BsArrowRight />}
                >
                  {banner.button_text}
                </ToogleLinkButton>
              ) : null}
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
};

export default HPBanner;
